var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalculatorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 18H3C1.3 18 0 16.7 0 15V3C0 1.3 1.3 0 3 0H11C12.7 0 14 1.3 14 3V15C14 16.7 12.7 18 11 18ZM3 2C2.4 2 2 2.4 2 3V15C2 15.6 2.4 16 3 16H11C11.6 16 12 15.6 12 15V3C12 2.4 11.6 2 11 2H3Z",
    fill: "#1570EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9C4.55228 9 5 8.55228 5 8C5 7.44772 4.55228 7 4 7C3.44772 7 3 7.44772 3 8C3 8.55228 3.44772 9 4 9Z",
    fill: "#1570EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9C7.55228 9 8 8.55228 8 8C8 7.44772 7.55228 7 7 7C6.44772 7 6 7.44772 6 8C6 8.55228 6.44772 9 7 9Z",
    fill: "#1570EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9C10.5523 9 11 8.55228 11 8C11 7.44772 10.5523 7 10 7C9.44772 7 9 7.44772 9 8C9 8.55228 9.44772 9 10 9Z",
    fill: "#1570EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12C4.55228 12 5 11.5523 5 11C5 10.4477 4.55228 10 4 10C3.44772 10 3 10.4477 3 11C3 11.5523 3.44772 12 4 12Z",
    fill: "#1570EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7.55228 12 8 11.5523 8 11C8 10.4477 7.55228 10 7 10C6.44772 10 6 10.4477 6 11C6 11.5523 6.44772 12 7 12Z",
    fill: "#1570EF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12C10.5523 12 11 11.5523 11 11C11 10.4477 10.5523 10 10 10C9.44772 10 9 10.4477 9 11C9 11.5523 9.44772 12 10 12Z",
    fill: "#1570EF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15C4.55228 15 5 14.5523 5 14C5 13.4477 4.55228 13 4 13C3.44772 13 3 13.4477 3 14C3 14.5523 3.44772 15 4 15Z",
    fill: "#1570EF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15C7.55228 15 8 14.5523 8 14C8 13.4477 7.55228 13 7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15Z",
    fill: "#1570EF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15C10.5523 15 11 14.5523 11 14C11 13.4477 10.5523 13 10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15Z",
    fill: "#1570EF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4V5H4V4H10ZM11 3H3V6H11V3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorIcon);
export default __webpack_public_path__ + "static/media/calculator_icon.b78346d60da0992cb5bd3676ca87b832.svg";
export { ForwardRef as ReactComponent };